import {
  NavigationContainer
} from '@react-navigation/native';
import {
  createNativeStackNavigator 
} from '@react-navigation/native-stack';
import React from 'react';
import TabNavigator from './tab';
import ErrorScreen from "../src/screens/configError";

const Stack = createNativeStackNavigator ();
const RootNavigation = ({...props}) => (
  <NavigationContainer >
    <Stack.Navigator
      screenOptions={{
        cardOverlayEnabled: true,
        gestureEnabled: false,
      }}>
      <Stack.Screen
        {...props}
        name={"TabNav"}
        component={TabNavigator}
        initialParams={{
          siteURL: props.siteURL,
          navConfig:  props.config.bottomBarNav,
          topBarNavStyles: props.config.topBarNav,
          hideSections: {
            header: props.config.headerToHide,
            footer: props.config.footerToHide,
            others: props.config.otherHide,
          },
          endFlowURLS: []
        }}
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name={"Config Error"}
        component={ErrorScreen}
        options={{
          headerShown: false,
        }}
      />
    </Stack.Navigator>
  </NavigationContainer>
);
export default RootNavigation;
